<h2 mat-dialog-title>Forgot Password</h2>
<mat-dialog-content>
  @if (!showCodeForm()) {
    <mat-form-field>
      <mat-label>Email Address</mat-label>
      <input matInput [formControl]="usernameControl" required>
    </mat-form-field>
    @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
    }
  } @else {
    <p>A verification code has been sent to your email.</p>
    <mat-form-field>
      <mat-label>Verification Code</mat-label>
      <input matInput [formControl]="codeControl" required>
    </mat-form-field>
    <mat-form-field>
      <mat-label>New Password</mat-label>
      <input matInput [formControl]="newPasswordControl" type="password" required>
    </mat-form-field>
    @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  @if (!showCodeForm()) {
    <button mat-button color="primary" [disabled]="usernameControl.invalid" (click)="requestPasswordReset()">
      Send Code
    </button>
  } @else {
    <button mat-button color="primary" [disabled]="codeControl.invalid || newPasswordControl.invalid" (click)="confirmPasswordReset()">
      Reset Password
    </button>
  }
</mat-dialog-actions>